
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideogram-ai-image-generator",
      function () {
        return require("private-next-pages/ideogram-ai-image-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideogram-ai-image-generator"])
      });
    }
  